import { RecentlyViewed } from '@df/catalog-ui/recently-viewed/recently-viewed.interfaces';

export const recentlyViewedConfig: RecentlyViewed.IConfig = {
    /**
     * Service mode, allowed values
     * top - saves only top level products
     * child - saves only child products
     * any - save any products viewed
     * @type {string}
     */
    mode: 'top',
    /**
     * Max items in storage
     * @type {number}
     */
    limit: 15
};
